<template>
  <!--<transition name="fade" appear>-->
  <div class="outer">
    <div class="timelabels">
      <span v-for="tlabel in timeLabels" :key="tlabel">{{ tlabel }}</span>
    </div>
    <div class="calendar">
      <div class="day" v-for="(day, idx) in result" :key="day">
        <div class="daylabel">
          <span>{{ getDate(day[0]) }}</span>
          <p>{{ getDay(day[0]) }}</p>
        </div>
        <HourBox :day="day" :idx="idx" />
      </div>
    </div>
  </div>
  <!--</transition>-->
</template>

<script>
import { getDate, getDay } from "../utils";
import HourBox from "./HourBox.vue";
import { useStore } from "vuex";
import { computed, toRefs } from "vue";

export default {
  components: { HourBox },
  props: {
    page: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const { page } = toRefs(props);

    return {
      availability: computed(() => store.getters.getAvailability),
      result: computed(() => store.getters.getSplitAvailabilities[page.value]),
      getDate,
      getDay,
      timeLabels: computed(() => store.getters.getTimeLabels),
    };
  },
};
</script>

<style scoped>
.outer {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  width: 100%;
  overflow-x: scroll;
  overflow-y: visible;
  max-height: 70vh;
  padding-bottom: 0.5rem;
  -webkit-overflow-scrolling: touch;
}

.calendar {
  display: inline-flex;
  flex-direction: row;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: visible;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  gap: 0;
}

.timelabels {
  color: #a3a3a3;
  padding-top: 70px;
  padding-bottom: 20px;
  display: flex;
  align-self: stretch;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 0.75rem;
  padding-left: 0.5rem;
  text-align: right;
  white-space: nowrap;
  font-size: 0.75rem;
  font-weight: 400;
  position: sticky;
  left: 0;
  background-color: #fafafa;
  z-index: 10;
}

.timelabels span {
  font-size: 0.75rem;
}

.day {
  text-align: center;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.daylabel {
  color: #525252;
  text-align: center;
  padding: 0.875rem 0;
  background: #fafafa;
  border-bottom: 1px solid #f5f5f5;
  margin: 0;
  width: 6rem;
  box-sizing: border-box;
}

.daylabel span {
  display: block;
  font-size: 1.125rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 0.25rem;
}

.daylabel p {
  font-size: 0.75rem;
  color: #737373;
  margin: 0;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 0.02em;
}

@media (max-width: 768px) {
  .outer {
    gap: 0.5rem;
  }

  .calendar {
    border-radius: 8px;
  }

  .timelabels {
    padding-top: 60px;
    padding-right: 0.5rem;
    font-size: 0.7rem;
  }

  .daylabel {
    padding: 0.75rem 0;
    width: 4.5rem;
  }

  .daylabel span {
    font-size: 1rem;
  }

  .daylabel p {
    font-size: 0.7rem;
  }
}
</style>
